<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div id="main">
        <section class="artWorkCateTop">
          <div v-if="this.$route.path.indexOf('/organizer') >= 0" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>主催者企画</h1>
              <p class="titleSub">Exhibitions by Organizer</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->


          <div v-if="isSelected('/organizer')" class="artWorkInfo">
            <div class="inner2">
              <p class="mainTxt">
                写真には一枚の写真を楽しむ単写真と、複数の写真を組み合わせて作品とする組写真があります。それぞれに面白みがあるのですが、SNSなどではその画面構成から単写真の方が多く投稿される傾向があります。
              </p>
              <p class="mainTxt">
                こうした現状を踏まえて東京カメラ部では、組写真の面白さも知っていただきたいと考えてこちらの部門を立ち上げました。しかし、３X３の写真を組み合わせて作品を作るこの部門は組写真であるが故に見る際に一定以上のサイズが必要となります。そのため、実際の展示で見ていただきたいという思いがあり、2019年を最後に2年連続で開催していませんでしたが、今年渋谷ヒカリエで展示会を開催することとなり復活をいたしました。オンラインですと画面のサイズなどから少し見にくいかもしれませんので、ぜひ拡大して御覧ください。
              </p>
            </div><!-- /inner2-->
          </div><!-- /artWorkInfo-->

          <div class="artWorkCateTopBody">
            <div class="inner2">

              <div v-if="this.$route.path.indexOf('/organizer') >= 0" class="listBlock">
                <template v-for="category of ['Instagram部門（３×３）']">
                  <div :key="category">
                    <h2>{{category}}</h2>
                      
                    <div class="listBlockInner">
                      <template v-for="(winner, index) of winnerListByCategory(category)">
                        <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                          <div class="thumbnailImg">
                              <router-link :to="workUrl(winner)">
                                <img :src="winner.mainImageUrl" :alt="winner.mainImageTitle" />
                              </router-link>
                          </div>
                          <h3><router-link :to="workUrl(winner)">{{ winner.nameOption1 }}</router-link></h3>
                        </div>
                      </template>
                    </div><!-- /listBlockInner-->

                  </div>
                </template>
              </div><!-- /listBlock-->
            </div><!-- /inner2-->
          </div><!-- /photographersListBody-->
        </section><!-- /photobook-->

      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    winnerListByCategory (category) {
      return this.winners.filter((winner) => {
        if (category.indexOf('Instagram部門（３×３）') >= 0) {
          return winner.awardType === this.EnumAwardTypeInstagram
        }
      })
    },
    workUrl (winner) {
      let path = ''
      if (winner.awardType == this.EnumAwardTypeCastleAndMoon) {
        path = `/organizer/castleandmoon/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTwitter) {
        path = `/organizer/twitter/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeInstagram) {
        path = `/organizer/instagram/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeJtg) {
        path = `/organizer/jtg/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeWeibo) {
        path = `/organizer/weibo/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeMonogatary) {
        path = `/organizer/monogatary/${winner.id}`
      }
      return path
    },
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
